// client/src/utils/chartTheme.js

// Palette catégorielle de l'identité (émeraude/or), utilisée par les graphes
// ApexCharts des pages Analytics, CsgoOverview et InvestmentsOverview.
export const CHART_PALETTE = [
  '#0e7c5e', // émeraude (accent)
  '#b8863b', // or
  '#3d6a99', // bleu acier
  '#9B5DE5', // violet
  '#4ECDC4', // sarcelle
  '#c97b8f', // rose mat
  '#B5B2A8' // taupe
];

export const CHART_AXIS_LABEL_STYLE = { colors: '#94a3b8' };

export const CHART_GRID_COLOR = '#f1f5f9';

export const CHART_TOOLTIP_DARK_THEME = { theme: 'dark' };
